<!-- 此文件为代理文件，只是为了声明比el-cascader组件多出来的属性，方便查看,并且用于覆盖饿了么的cascader组件，所以起一样的名字 -->
<script>
import { TableColumn } from 'element-ui'

export default {
	extends: TableColumn,
	name: 'ElTableColumn',
	// 以下只展示覆盖el-cloumn的属性
	props: {
		// 默认不让用户手动拉伸表格列
		resizable: {
			type: Boolean,
			default: false
		},
		headerAlign: {
			type: String,
			default: 'center'
		},
		align: {
			type: String,
			default: 'center'
		}
	}
}
</script>
